const API_ROOT = (process.env.REACT_APP_LOCAL_HOST || 'http://127.0.0.1:8000/api/v1')
    .replace(/\/api\/v1\/?$/i, '')
    .replace(/\/$/, '');

function extractStoragePath(url) {
    if (!url || typeof url !== 'string') return '';
    const trimmed = url.trim();

    if (/^https?:\/\//i.test(trimmed) || trimmed.startsWith('//')) {
        const match = trimmed.match(/\/(?:media|storage)\/(.+)$/i);
        return match ? match[1] : '';
    }

    return trimmed
        .replace(/^\/+/, '')
        .replace(/^(?:media|storage)\//i, '');
}

/** Turn API relative/absolute upload paths into browsable URLs on the API host. */
export function resolveMediaUrl(url) {
    if (!url || typeof url !== 'string') return '';

    const trimmed = url.trim();
    if (!trimmed) return '';

    const storagePath = extractStoragePath(trimmed);
    if (storagePath) {
        // Prefer /media/ which is served by Laravel (works without storage symlink).
        return `${API_ROOT}/media/${storagePath}`;
    }

    if (/^https?:\/\//i.test(trimmed) || trimmed.startsWith('//')) {
        return trimmed.startsWith('//') ? `http:${trimmed}` : trimmed;
    }

    return `${API_ROOT}/media/${trimmed.replace(/^\/+/, '')}`;
}

export function resolveCourseImage(item) {
    if (!item) return '';
    return resolveMediaUrl(
        item.image ||
        item.image_url ||
        item.cover ||
        item.cover_url ||
        item.related_data?.image ||
        ''
    );
}

export default resolveMediaUrl;
